import Polyglot from 'node-polyglot';

const deTranslations = {
  "title": "architekt*innen",
  "subtitle": "GmbH",
  "city": "Zürich",
};

const enTranslations = {
  "title": "architects",
  "subtitle": "Ltd.",
  "city": "Zurich",
};

const frTranslations = {
  "title": "architectes",
  "subtitle": "Sàrl",
  "city": "Zurich",
};

const getTranslation = (loc) => {
  if(loc === "de") {
    return deTranslations;
  } else if (loc === "en") {
    return enTranslations;
  } else if (loc === "fr") {
    return frTranslations;
  } else return deTranslations;
};

const changeLocale = (loc) => {
  const polyglot = new Polyglot({
    phrases: getTranslation(loc)
  });

  const title =  document.querySelector(".title");
  title.textContent = polyglot.t("title");

  const subtitle =  document.querySelector(".subtitle");
  subtitle.textContent = polyglot.t("subtitle");

  const city =  document.querySelector(".city");
  city.textContent = polyglot.t("city");

  document.documentElement.lang = loc;
};

export { changeLocale };